import { useQuery } from "@tanstack/react-query"

import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
import { DateHelper, StringHelper } from "@/utils"
const defaultersOrder = async (
  params: DefaultersSearchParams
) => {
  const newParams = {
    ...params,
    document: StringHelper.onlyAlphanumeric(
      params.document
    ),
    startDateTime: DateHelper.formatToISO(
      params.startDateTime
    ),
    endDateTime: DateHelper.formatToISO(params.endDateTime),
  }
  const queryString =
    StringHelper.objectToQueryString(newParams)
  const url = `${ENDPOINTS.DEFAULTER_ORDER}?${queryString}`
  const { data } =
    await api.get<DefaultersOrderResponseType>(url)
  return data
}
const useDefaultersOrder = (
  params: DefaultersSearchParams,
  enabled = false
) => {
  return useQuery({
    queryKey: [ENDPOINTS.DEFAULTER_ORDER, params],
    queryFn: async () => defaultersOrder(params),
    enabled,
  })
}
export default useDefaultersOrder
